import { defineMessages } from 'react-intl';

export const tipsNewsMessages = defineMessages({
  panelTitle: { id: 'tipsNews.panel.title', defaultMessage: 'Tips & News' },
  emptyState: { id: 'tipsNews.panel.emptyState', defaultMessage: 'No new tips right now.' },
  dismiss: { id: 'tipsNews.panel.dismiss', defaultMessage: 'Got it' },
  learnMore: { id: 'tipsNews.panel.learnMore', defaultMessage: 'Learn more' },
  ariaLabel: { id: 'tipsNews.panel.ariaLabel', defaultMessage: 'Tips & News' },
  tagNew: { id: 'tipsNews.tag.new', defaultMessage: 'New' },
  tagTip: { id: 'tipsNews.tag.tip', defaultMessage: 'Tip' },
  tagInfo: { id: 'tipsNews.tag.info', defaultMessage: 'Info' },
  tagBestPractice: { id: 'tipsNews.tag.bestPractice', defaultMessage: 'Best Practice' },
});
